import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft } from "@phosphor-icons/react";
import { C } from "@/components/fm/shared";
import FmInterview from "@/components/fm/FmInterview";
import { normalizeModelCtx } from "@/lib/fmInterview";
import David from "@/components/David";

export default function FinModelInterview() {
  const { fmId } = useParams();
  const navigate = useNavigate();
  const [model, setModel] = useState(null);

  useEffect(() => {
    api.get(`/fm/models/${fmId}`).then((r) => setModel(normalizeModelCtx(r.data))).catch(() => navigate("/dashboard"));
  }, [fmId, navigate]);

  if (!model) return <div className="min-h-screen" style={{ backgroundColor: C.bg }} />;

  return (
    <div className="min-h-screen pb-24" style={{ backgroundColor: C.bg, fontFamily: "Manrope, sans-serif" }} data-testid="fm-interview-page">
      <header className="border-b border-white/10 px-6 py-4 flex items-center justify-between sticky top-0 z-20" style={{ backgroundColor: C.bg }}>
        <div className="flex items-center gap-4">
          <button onClick={() => navigate(`/fm/${fmId}`)} className="text-white/60 hover:text-white" data-testid="fm-interview-back"><ArrowLeft size={18} /></button>
          <div>
            <div className="text-white font-extrabold">{model.name} — edit answers</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-white/40">Jump to any section · every change saves live</div>
          </div>
        </div>
        <Link to={`/fm/${fmId}`} className="text-xs font-bold px-3.5 py-2 rounded-md" data-testid="fm-interview-open-model"
          style={{ backgroundColor: "rgba(255,255,255,0.06)", color: "#fff" }}>
          View model
        </Link>
      </header>
      <main className="max-w-4xl mx-auto px-6 py-10">
        <FmInterview model={model} setModel={setModel} mode="live" startSection={1}
          onDone={() => navigate(`/fm/${fmId}`)} />
      </main>
      <David />
    </div>
  );
}
